import React from "react";

const ConfirmationModal = ({ confirmModal, setConfirmModal, message, handleConfirm }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-[350px]">
        <h2 className="text-lg font-semibold mb-4">{message?.title}</h2>
        <p className="text-sm text-gray-600 mb-6">
          {message?.content}
        </p>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-lg border"
            onClick={() => setConfirmModal(false)}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-lg bg-blue-600 text-white"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;